import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import { useState, useRef, useCallback, useEffect } from 'react';
import { BsCameraVideo } from '@react-icons/all-files/bs/BsCameraVideo';
import { EditorPlaceholder } from '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver.js';
import { jsx } from '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Video(_ref) {
  var src = _ref.src,
    poster = _ref.poster,
    loop = _ref.loop,
    muted = _ref.muted,
    autoplay = _ref.autoplay;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    video = _useState2[0],
    setVideo = _useState2[1];
  var isPlaying = useRef(false);
  var play = useCallback(function () {
    if (!video) {
      return;
    }
    if (isPlaying.current) {
      return;
    }
    video.play();
    isPlaying.current = true;
  }, [video]);
  var pause = useCallback(function () {
    if (!video) {
      return;
    }
    if (!isPlaying.current) {
      return;
    }
    video.pause();
    isPlaying.current = false;
  }, [video]);
  var stop = useCallback(function () {
    if (!video) {
      return;
    }
    video.currentTime = 0;
    video.pause();
    isPlaying.current = false;
  }, [video]);
  function handleEnded() {
    isPlaying.current = false;
  }
  useEffect(function () {
    if (autoplay) {
      play();
    }
  }, [src, loop]);
  useEffect(function () {
    autoplay ? play() : stop();
  }, [autoplay]);
  useIntersectionObserver({
    target: video,
    onIntersect: function onIntersect() {
      return autoplay && play();
    },
    onEscape: pause
  });
  useEffect(function () {
    function handlePageShow() {
      if (isPlaying.current) {
        play();
      }
    }
    window.addEventListener('pageshow', handlePageShow);
    return function () {
      return window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);
  if (!src) {
    return jsx(EditorPlaceholder, {
      icon: jsx(BsCameraVideo, null),
      message: "\uBE44\uB514\uC624\uB97C \uB4F1\uB85D\uD574\uC8FC\uC138\uC694."
    });
  }
  return jsx(Player, {
    preload: "metadata",
    ref: function ref(el) {
      return setVideo(el);
    },
    src: "".concat(src, "#t=0.5"),
    loop: loop,
    muted: muted,
    controls: !autoplay,
    onEnded: handleEnded,
    playsInline: true,
    poster: poster
  });
}
var Player = /*#__PURE__*/_styled("video", process.env.NODE_ENV === "production" ? {
  target: "e1hntkd0"
} : {
  target: "e1hntkd0",
  label: "Player"
})(process.env.NODE_ENV === "production" ? {
  name: "1bcj5ek",
  styles: "width:100%;display:block"
} : {
  name: "1bcj5ek",
  styles: "width:100%;display:block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { Video };
//# sourceMappingURL=Video.js.map
